import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** 固定資産増減合計表帳票種類 */
enum FixedAssetIncDecSummary {
  summary = '1',
  details = '2',
}

const nameConfig = {
  summary: new Map([[Locale.ja, '固定資産増減合計表']]),
  details: new Map([[Locale.ja, '固定資産増減合計表(詳細)']]),
};

const toEnum = rawValueToEnum(FixedAssetIncDecSummary, FixedAssetIncDecSummary.summary);
const toDisplay = enumToName(FixedAssetIncDecSummary, nameConfig);
const toDisplayWithPrefix = enumToName(FixedAssetIncDecSummary, nameConfig, { prefix: true });

export const fixedAssetIncDecSummary = {
  enum: FixedAssetIncDecSummary,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { FixedAssetIncDecSummary };
